import { createAction } from '@reduxjs/toolkit';


export const getAwsCognitoToken = createAction('GET_AWSCOGNITO_TOKEN', code => {
    return{
        payload: {
            code: code
        }
    }
});

export const updateAwsTokenSuccess = createAction('UPDATE_AWS_TOKEN_SUCCESS', result => {
    return{
        payload: {
            result: result
        }
    }
});

export const updateAwsTokenFailure = createAction('UPDATE_AWS_TOKEN_FAILURE', err => {
    return{
        payload: {
            err: err
        }
    }
});





export const getUserAttributes = createAction('GET_USER_ATTRIBUTES', userName => {
    return{
        payload: {
            userName: userName
        }
    }
});

export const getUserAttributesSuccess = createAction('GET_USER_ATTRIBUTES_SUCCESS', response => {
    return{
        payload: {
            response: response
        }
    }
});

export const getUserAttributesFailure = createAction('GET_USER_ATTRIBUTES_FAILURE', message => {
    return{
        payload: {
            message: message
        }
    }
});


export const setUserNameAction = createAction('SET_USERNAME', userName => {
    return{
        payload: {
            userName: userName
        }
    }
});


export const getAuthUser = createAction('GET_AUTH_USER', authUser => {
    return{
        payload: {
            authUser: authUser
        }
    }
});

export const initializaMerchantState = createAction('INITIALIZE_MERCHANT_STATE', authUser => {
    return{
        payload: {
            authUser: authUser
        }
    }
});

